import React from 'react';

const Matrix = props => {
  return (
    <svg width="31" height="30" viewBox="0 0 31 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M23.75 12H7.25v.938h16.5V12zM23.75 15.75H7.25v.937h16.5v-.937zM23.75 19.5H7.25v.938h16.5V19.5z" fill="currentColor" />
      <path d="M15.969 12.469h-.938v10.969h.938v-10.97z" fill="currentColor" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.5 7.2h-14a.8.8 0 0 0-.8.8v14a.8.8 0 0 0 .8.8h14a.8.8 0 0 0 .8-.8V8a.8.8 0 0 0-.8-.8zM8.5 6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-14z"
        fill="currentColor"
      />
    </svg>
  );
};

export default Matrix;
